import { useTranslate } from '@tolgee/react';
import { ActionButton } from '~/components/button/ActionButton';
import { useEffect, useRef, useState } from 'react';

type NavigationToolTipProps = {
  readonly navigationItem: JSX.Element;
  readonly link?: string;
  readonly linkButtonLabel?: string;
};

export function NavigationToolTip(props: NavigationToolTipProps) {
  const { t } = useTranslate();
  const [
    showTooltip,
    setShowTooltip,
  ] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const handleDocumentClick = (event: MouseEvent) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(event.target as Node)
    ) {
      setShowTooltip(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  const toggleTooltip = (e: any) => {
    e.stopPropagation();
    setShowTooltip(!showTooltip);
  };

  const item = props.navigationItem;

  return (
    <div
      className="relative z-50 group cursor-pointer w-full"
      ref={tooltipRef}
      onClick={toggleTooltip}
    >
      {item}
      {showTooltip && (
        <div className="p-4 bg-gray-300 dark:bg-gray-700 md:bg-black rounded-lg shadow-md dark:shadow-gray-900/50 fixed left-[8rem] transform -translate-y-[70%] w-80">
          <div className="flex flex-col gap-1 my-auto">
            <div className="text-black dark:text-gray-100 dark:text-white dark:text-gray-100 md:text-gray-300 mb-2">
              {t('navigation_menu_button_login_hint', {
                menuItem: t(
                  props.link ||
                    'navigation_menu_button_login_hint_default_page_name',
                ),
              })}
            </div>
            <a href={props.link || '/'}>
              <ActionButton primary>
                {t(props.linkButtonLabel || 'clerk_login_button')}
              </ActionButton>
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
